<template>
  <div class="row g-0">
    <!-- Columna Izquierda (7 columnas) -->
    <div class="col-12 col-lg-7 p-4">
      <!-- Detalles del curso skeleton -->
      <div class="mb-4">
        <div class="skeleton mb-3 animate-shimmer" style="width: 180px; height: 18px;"></div>
        <div class="skeleton rounded-3 animate-shimmer" style="width: 100%; height: 130px; background-color: #6d263a; opacity: 0.12;"></div>
      </div>
      
      <!-- Datos de banco skeleton -->
      <div class="mb-4">
        <div class="skeleton mb-3 animate-shimmer" style="width: 150px; height: 18px;"></div>
        <div class="skeleton rounded-3 animate-shimmer" style="width: 100%; height: 80px;"></div>
      </div>
      
      <!-- Selección de cuotas skeleton -->
      <div>
        <div class="skeleton mb-3 animate-shimmer" style="width: 160px; height: 18px;"></div>
        <div class="row g-3">
          <div class="col-6" v-for="i in 2" :key="'sk-concept-' + i">
            <div class="skeleton rounded-3 animate-shimmer" style="width: 100%; height: 95px;"></div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Columna Derecha (5 columnas, fondo sidebar) -->
    <div class="col-12 col-lg-5 p-4 border-start" style="background-color: #eef2f6;">
      <!-- Título -->
      <div class="skeleton mb-4 animate-shimmer" style="width: 160px; height: 22px;"></div>
      
      <!-- Items de resumen -->
      <div class="mb-4">
        <div class="d-flex justify-content-between mb-2" v-for="i in 3" :key="'sk-line-' + i">
          <div class="skeleton animate-shimmer" style="width: 100px; height: 14px;"></div>
          <div class="skeleton animate-shimmer" style="width: 60px; height: 14px;"></div>
        </div>
      </div>
      
      <!-- Recuadro total -->
      <div class="skeleton rounded-3 mb-4 animate-shimmer" style="width: 100%; height: 90px; background-color: white;"></div>
      
      <!-- Inputs del formulario -->
      <div class="mb-4">
        <div class="mb-3">
          <div class="skeleton mb-2 animate-shimmer" style="width: 100px; height: 12px;"></div>
          <div class="skeleton animate-shimmer" style="width: 100%; height: 38px;"></div>
        </div>
        <div class="row g-2 mb-3" v-for="i in 2" :key="'sk-input-row-' + i">
          <div class="col-6">
            <div class="skeleton mb-2 animate-shimmer" style="width: 80px; height: 12px;"></div>
            <div class="skeleton animate-shimmer" style="width: 100%; height: 38px;"></div>
          </div>
          <div class="col-6">
            <div class="skeleton mb-2 animate-shimmer" style="width: 80px; height: 12px;"></div>
            <div class="skeleton animate-shimmer" style="width: 100%; height: 38px;"></div>
          </div>
        </div>
      </div>
      
      <!-- Botón de reportar -->
      <div class="skeleton rounded-3 animate-shimmer" style="width: 100%; height: 50px;"></div>
    </div>
  </div>
</template>

<script setup>
// Pure presentational skeleton loader
</script>

<style scoped>
.skeleton {
  background-color: #e2e8f0;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  display: block;
}

.animate-shimmer::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.4) 20%,
    rgba(255, 255, 255, 0.6) 60%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: shimmer 1.6s infinite;
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
